import React from "react";
// import { FormField } from "../../particles/formFieldRHF";
// import { LabelTooltip } from "../../organisms/labelTooltip";
// import { NotificationCard } from "../../organisms/notificationCard";
import ReactCodeInput from "@acusti/react-code-input";
import { FormField, NotificationCard } from "@arp/react-ndbx";
import { FormControl, FormHelperText } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const RHFCodeInput = React.forwardRef((props, ref) => (
  <FormField ref={ref} Component={RHFCodeInputImpl} {...props} />
));

const RHFCodeInputImpl = React.forwardRef(
  (
    {
      name,
      className,
      variant,
      label,
      size,
      controlIdentifier,
      defaultValue,
      onChange,
      onBlur,
      onFocus,
      error,
      helperText,
      showTooltip = false,
      tooltipText = "PLEASE ADD TOOLTIP TEXT!",
      showErrorCard = true,
      extendedError = { title: null, additionalText: null },
      customError = false,
      digitCodeNumber = 6,
      ...props
    },
    ref
  ) => {
    const theme = useTheme();

    const reactCodeInputStyle = {
      fontFamily: "Allianz Neo",
      margin: "4px",
      MozAppearance: "textfield",
      width: "45px",
      borderRadius: "6px",
      fontSize: "20px",
      height: "45px",
      backgroundColor: "white",
      textAlign: "center",
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
    };

    const customProps = {
      inputStyle: {
        ...reactCodeInputStyle,
        color: theme.palette.greyscale.Grey500,
        border: `1px solid ${theme.palette.greyscale.Grey100}`,
      },
      inputStyleInvalid: {
        ...reactCodeInputStyle,
        color: theme.palette.signal.Error500,
        border: `1px solid ${theme.palette.signal.Error500}`,
      },
    };

    return (
      <FormControl sx={{ width: "100%" }} size={size} error={error}>
        <ReactCodeInput
          data-identifier={`codeinput-${controlIdentifier}`}
          id={`${name}-codeinput`}
          name={name}
          type="number"
          fields={digitCodeNumber}
          error={error}
          ref={ref}
          {...props}
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={onChange}
          {...customProps}
          isValid={helperText || customError ? false : true}
        />
        {helperText && showErrorCard === true && (
          <NotificationCard
            sx={{ mt: 1 }}
            message={helperText}
            {...extendedError}
          />
        )}
        {helperText && showErrorCard === false && (
          <FormHelperText sx={{ color: theme.palette.signal.Error600 }}>
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
);

export default RHFCodeInput;
